import { render, staticRenderFns } from "./Project18Zh.vue?vue&type=template&id=0e050135&scoped=true&"
import script from "./Project18Zh.vue?vue&type=script&lang=js&"
export * from "./Project18Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project18Zh.vue?vue&type=style&index=0&id=0e050135&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e050135",
  null
  
)

export default component.exports